module.exports = __webpack_public_path__ + "static/media/usersNormal.25d6c0cd.svg";